import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrderMenuService {
  private dataChangedSource = new Subject<any>();
  dataChanged$ = this.dataChangedSource.asObservable();

  notifyDataChanged(data?: any) {
    this.dataChangedSource.next(data);
  }
}